export enum BannerActionTypes {
    API_RESPONSE_SUCCESS = "@@banner/API_RESPONSE_SUCCESS",
    API_RESPONSE_ERROR = "@@banner/API_RESPONSE_ERROR",
  
    CREATE_BANNER = "@@banner/CREATE_BANNER",
    GET_BANNER = "@@banner/GET_BANNER",
    UPDATE_BANNER = "@@banner/UPDATE_BANNER",
    DELETE_BANNER = "@@banner/DELETE_BANNER",
    DELETE_BANNER_IMAGE = "@@banner/DELETE_BANNER_IMAGE",
  }